import React, { useContext, useState, useEffect } from "react";
import { Form, Formik } from "formik";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  UncontrolledDropdown,
} from "reactstrap";
import { Power, User } from "react-feather";
import Avatar from "../../../../../components/@vuexy/avatar/AvatarComponent";
import { UserRoles } from "../../../../../core/enums/user-role.enum";
import { useHistory } from "react-router";
import { showToast } from "../../../../../core/utils/show-toast";
import { ToastTypes } from "../../../../../core/enums/toast-types.enum";
import { ShowImage } from "../../../../../components/common/DownloadRow/ShowImage/ShowImage";
import { SimpleSubmitButton } from "../../../../../components/common/Form/SubmitButtonComponent/SimpleSubmitBtn/SimpleSubmitButton";
import  {UserRolesPersian}  from "../../../../../core/enums/user-role-persian.enum";



const UserDropdown = (props) => {
  const history = useHistory();
  return (
    <DropdownMenu right className="w-100">
      <DropdownItem
        tag="a"
        onClick={props.onEditProfileLinkClicked}
        className="w-100"
      >
        <User size={14} className="mr-50" />
        <span className="align-middle">پروفایل</span>
      </DropdownItem>
      <DropdownItem
        className="w-100"
        onClick={() => {
          showToast(["در حال خروج از سایت"], ToastTypes.info);
          localStorage.removeItem("havePassword");
          history.push("/signout-oidc");
        }}
      >
        <Power size={14} className="mr-50" />
        <span className="align-middle" onClick={() => {}}>
          خروج
        </span>
      </DropdownItem>
    </DropdownMenu>
  );
};

const EditProfileModal = ({
  roles,
  userName,
  isOpen,
  modalToggled,
  nationalCode,
  userProfilePicture,
}) => {
  const [isUploading, setIsUploading] = useState(false);
  const [isShow, setIsShow] = useState(false);

  const handleSubmit = (value) => {
   
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={modalToggled}
      className="modal-dialog-centered"
    >
      {userProfilePicture && (
        <ShowImage
          isOpen={isShow}
          modalSize="md"
          toggle={() => setIsShow(false)}
          image={userProfilePicture}
        />
      )}
      <Formik
        enableReinitialize
        initialValues={{ file: null }}
        onSubmit={handleSubmit}
      >
        {(params) => {
          return (
            <Form>
              <ModalHeader toggle={modalToggled} className="bg-info">
                 پروفایل
              </ModalHeader>
              <ModalBody className="modal-dialog-centered">
                <Card className="w-100 shadow-none m-0">
                  <CardHeader className="mx-auto">
                    <div className="avatar mr-1 avatar-xl">
                      {userProfilePicture ? (
                        <>
                          <img
                            src={userProfilePicture}
                            alt="profile"
                            width="200"
                            height="200"
                            style={{ objectFit: "cover" }}
                            onClick={() => setIsShow(true)}
                          />
                        </>
                      ) : (
                        <Avatar icon={<User />} />
                      )}
                    </div>
                  </CardHeader>
                  {/* <div className="d-flex justify-content-center">
                    {userProfilePicture && (
                      <SimpleSubmitButton
                        outLine
                        color="danger"
                        onCLick={() => {
                        }}
                        isLoading={false} //removeProfile.isLoading}
                        type="button"
                        btnText="حذف پروفایل"
                      />
                    )}
                  </div> */}
                  <CardBody className="text-center mb-0 pb-0">
                    <h4>{userName}</h4>
                    <h4>کد ملی: {nationalCode}</h4>
                    <p>
                      {roles && Array.isArray(roles) ? (
                        <>
                          {roles.map((role) => {
                            return (
                              <>
                                <Badge color="light-success" pill>
                                  {UserRolesPersian[role]}
                                </Badge>
                              </>
                            );
                          })}
                        </>
                      ) : (
                        <>
                          <Badge color="light-success" pill>
                            {UserRolesPersian[roles]}
                          </Badge>
                        </>
                      )}
                    </p>
                    {/* <hr className="my-2" /> */}
                    {/* <Row>
                      <Col className="text-left" md="12" sm="12">
                        <ProfileDropZone
                          lableText="انتخاب تصویر پروفایل"
                          name="file"
                          accept={
                            "image/jpeg, image/png, image/jpg, image/tif,image/tiff"
                          }
                          significant={false}
                          isSingle={true}
                        />
                      </Col>
                    </Row> */}
                  </CardBody>
                </Card>
              </ModalBody>
              {/* <ModalFooter className="justify-content-start">
                <SimpleSubmitButton
                  isLoading={isUploading}
                  color="info"
                  btnText="ذخیره"
                />
                <Button outline color="danger" onClick={modalToggled}>
                  انصراف
                </Button>
              </ModalFooter> */}
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
};

const NavbarUser = (props) => {
  const [isEditProfileModalOpen, setIsEditProfileModalOpen] = useState(false);
  const [role, setRole] = useState([]);
  const [roleName, setRoleName] = useState("نامشخص");

  useEffect(() => {
    if (props?.role && props?.role.length > 0) {
      setRole(props?.role);
    }
  }, [props?.role]);

  useEffect(() => {
    if (role && role.length > 0) {
      switch (true) {
        case role && role.includes(UserRoles.Admin):
          setRoleName("ادمین");
          break;
        case role && role.includes(UserRoles.UserReal):
          setRoleName("کاربر حقیقی");
          break;
        case role && role.includes(UserRoles.UserLegal):
          setRoleName("کاربر حقوقی");
          break;
        default:
          break;
      }
    }
  }, [role]);


  
  const toggleEditProfileModal = () => {
    setIsEditProfileModalOpen((val) => !val);
  };

  const editProfileLinkClicked = () => {
    toggleEditProfileModal();
  };


  return (
    <>
    <EditProfileModal
        isOpen={isEditProfileModalOpen}
        modalToggled={toggleEditProfileModal}
        roles={role}
        nationalCode={props.nationalCode}
        userName={props.userName}
        userProfilePicture={props.userImg}
      />


      <ul className="nav navbar-nav navbar-nav-user float-right">
        <UncontrolledDropdown tag="li" className="dropdown-user nav-item">
          <DropdownToggle tag="a" className="nav-link dropdown-user-link">
            <div className="user-nav d-sm-flex d-none">
              <span className="user-name text-bold-600">{props?.userName}</span>
              <Badge color="danger">{roleName}</Badge>
            </div>

            <span data-tour="user">
              {props?.userImg ? (
                <img
                  src={props?.userImg}
                  className="round"
                  height="40"
                  width="40"
                  alt="avatar"
                  style={{ objectFit: "cover" }}
                />
              ) : (
                <Avatar className="mr-1" icon={<User />} />
              )}
            </span>
          </DropdownToggle>
          <UserDropdown   onEditProfileLinkClicked={editProfileLinkClicked}
            {...props} />
        </UncontrolledDropdown>
      </ul>
    </>
  );
};

export default NavbarUser;
